<div class="u-file-upload">
  <u-button
    [versionNumber]="2"
    [label]="label()"
    [styleType]="styleType()"
    [fontIcon]="fontIcon()"
    [styles]="styles()"
    [typeElement]="typeElement()"
    [stateElement]="stateElement()"
    [iconStyles]="iconStyles()"
    [customSize]="customSize()"
    (onClick)="openFileDialog($event)"
    [sizeElement]="sizeElement()"
  >
    @if (filePreviewUrl()) {
      <img class="file-preview" [src]="filePreviewUrl() | safe: 'resource'" />
    }
  </u-button>

  <input
    #fileInput
    type="file"
    [accept]="acceptTypesString()"
    [multiple]="multiple()"
    (change)="onFileSelected($event)"
    (cancel)="onCancel.emit()"
    style="display: none"
  />
</div>
